var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    attrs: {
      title: (_vm.form.id ? "编辑" : "新增") + "问题",
      width: "800px",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.close
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c("el-form-item", [_c("el-radio-group", {
    model: {
      value: _vm.lang,
      callback: function callback($$v) {
        _vm.lang = $$v;
      },
      expression: "lang"
    }
  }, [_c("el-radio-button", {
    attrs: {
      label: "zh"
    }
  }, [_vm._v("中文")]), _c("el-radio-button", {
    attrs: {
      label: "en"
    }
  }, [_vm._v("英文")]), _c("el-radio-button", {
    attrs: {
      label: "tw"
    }
  }, [_vm._v("繁体")])], 1)], 1), _vm.lang === "zh" ? [_c("el-form-item", {
    attrs: {
      label: "问题",
      prop: "questionZh"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.questionZh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "questionZh", $$v);
      },
      expression: "form.questionZh"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "回答",
      prop: "answerZh"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 10
      },
      "show-word-limit": "",
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.answerZh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "answerZh", $$v);
      },
      expression: "form.answerZh"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "示意图",
      prop: "imgs"
    }
  }, [_c("SchematicImg", {
    attrs: {
      max: _vm.max
    },
    model: {
      value: _vm.form.imgs,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "imgs", $$v);
      },
      expression: "form.imgs"
    }
  })], 1)] : _vm.lang === "en" ? [_c("el-form-item", {
    attrs: {
      label: "question",
      prop: "questionEn"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.questionEn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "questionEn", $$v);
      },
      expression: "form.questionEn"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "answer",
      prop: "answerEn"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 10
      },
      "show-word-limit": "",
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.answerEn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "answerEn", $$v);
      },
      expression: "form.answerEn"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "示意图",
      prop: "imgsEn"
    }
  }, [_c("SchematicImg", {
    attrs: {
      max: _vm.max
    },
    model: {
      value: _vm.form.imgsEn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "imgsEn", $$v);
      },
      expression: "form.imgsEn"
    }
  })], 1)] : _vm.lang === "tw" ? [_c("el-form-item", {
    attrs: {
      label: "問題",
      prop: "questionTw"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.questionTw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "questionTw", $$v);
      },
      expression: "form.questionTw"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "回答",
      prop: "answerTw"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 10
      },
      "show-word-limit": "",
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.answerTw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "answerTw", $$v);
      },
      expression: "form.answerTw"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "示意图",
      prop: "imgsTw"
    }
  }, [_c("SchematicImg", {
    attrs: {
      max: _vm.max
    },
    model: {
      value: _vm.form.imgsTw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "imgsTw", $$v);
      },
      expression: "form.imgsTw"
    }
  })], 1)] : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "推荐",
      prop: "isRecommend"
    }
  }, [_c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.form.isRecommend,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "isRecommend", $$v);
      },
      expression: "form.isRecommend"
    }
  })], 1)], 2), _c("div", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };